import {API_SERVERLESS, postFetch} from '~commonApi';

export function apiCertifiedCopiesCheckTitles(applicationTitles: string[]) {
    return postFetch(`${API_SERVERLESS}/common/v3/checkTitles`, true, {
        applicationTitles,
    });
}
